import Sidebar from '../components/Sidebar.jsx';
import PageHeader from '../components/PageHeader.jsx';
import Graph1 from '../components/Graph.jsx';
import '../styles/Graphsbg.css';

const Software = () => {
	let CoverPic = 'https://static.igem.wiki/teams/5066/global/bgpic.png';

	let sections = [
		{ id: 's1', name: 'About the Model' },
		{ id: 's2', name: 'Making process' },
	];

	return (
		<div className='bg-[#d9eaf0]'>
			<PageHeader
				img={CoverPic}
				title='Software&nbsp;X&nbsp;Drylab&nbsp;Model'
				customPicture={
					<img
						src={
							'https://static.igem.wiki/teams/5066/cover/software.gif'
						}
						alt='Custom'
						className='w-44 h-44'
					/>
				}
			/>

			<div className='flex flex-col md:flex-row bg-gradient-to-b from-[#d9eaf0] via-[#e8f3f7] to-[#feedfb]'>
				<Sidebar sections={sections} />

				{/* Main Content */}
				<div className='w-full md:w-9/10 p-4 md:p-[80px] space-y-8 md:space-y-16 rounded-2xl bg-[#fffdf2] shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.4)]'>
					<div className='pb-12'>
						<section id='s1'>
							<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
								About the Model
							</h2>
							<p className='mt-2 text-gray-700 leading-relaxed'>
								This is an interactive model that illustrates
								the dynamics of the larvae, adult mosquito, and
								human population in the cross-transmission
								process. The interactive model outputs diagrams
								according to user manipulation of factors that
								affect dengue disease transmission.
							</p>
							<h1 className='mt-2 text-xl font-bold text-gray-700 leading-relaxed'>
								Overview of the Model:{' '}
							</h1>
							<p className='mt-2 text-gray-700 leading-relaxed'>
								Available also in the Model Page
								(Epidemiological Model)!
							</p>
							<p className='mt-2 italic text-gray-700 leading-relaxed'>
								Try out the model by entering numbers and scrolling the bars, 
								<br />
								then press the "Run model!" button to see the model!
							</p>
							<br></br>
							<div className='pink-box '>{<Graph1 />}</div>
						</section>
					</div>

					<div className='pb-12'>
						<section id='s2'>
							{/* Sticky note */}
							<div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
								<span className='text-gray-800 font-bold'></span>
							</div>
							<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
								Making process
							</h2>
							<p className='mt-2 text-gray-700 leading-relaxed'>
								These models were programmed using the language
								R in <strong>RStudios</strong> initially. In
								Rstudios, the graphs were created using an
								embedded ODE algorithm built into Rstudios.
								Programming for this model on the Wiki was
								programmed in the language Javascript. Since
								there isn’t an embedded ODE algorithm built into
								Javascript, the graphs were produced through the
								use of for loops. The for loop would iterate
								through a set number of iterations, which the
								user could manipulate; during each iteration,
								individual data points would be calculated using
								Euler’s method from differential equations
								sourced from literature (see Equations and
								Parameters). Since a greater number of
								iterations would increase the accuracy of
								Euler’s method for curve estimation, one
								iteration doesn’t represent one day in the
								disease transmission process; rather, one
								iteration is a fragment of the standard unit of
								time (days).
							</p>
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Software;
